import { type ReactNode, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

type Props = { target?: HTMLElement | null; children: ReactNode };

export const Portal = ({ children, target = globalThis.document?.body }: Props) => {
  const [effectiveTarget, setEffectiveTarget] = useState<HTMLElement | null>(null);
  useEffect(() => {
    setEffectiveTarget(target);
  }, [target]);
  if (!effectiveTarget) {
    return null;
  }
  return createPortal(children, effectiveTarget);
};
